import r from"styled-components";import{theme as o}from"../../../theme.js";const i=r.button`
  padding: ${o.spacing}px ${o.spacing*4}px;
  border-radius: ${o.radius}px;
  background-color: ${o.colors.primary[50]};
  color: ${o.colors.primary[500]};
  display: grid;
  grid-template-columns: 18px max-content;
  align-items: center;
  grid-column-gap: ${o.spacing}px;
  border: none;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  cursor: pointer;
  > svg {
    width: 16px;
    height: 16px;
    > g, path {
      fill: ${o.colors.primary[300]};
    }
  }
  transition: all .1s ease-in-out;
  &:hover {
    background-color: ${o.colors.primary[500]};
    color: ${o.colors.shades[0]};
    > svg {
      > g, path {
        fill: ${o.colors.shades[0]};
      }
    }
  }
  &:disabled {
    background-color: ${o.colors.gray[300]};
    color: ${o.colors.gray[600]};
    cursor: not-allowed;
    > svg {
      > g, path {
        fill: ${o.colors.gray[600]};
      }
    }
  }
`;export{i as Button};
